// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum AccountingDocumentsInventoryChangeRestrictionLevel {
  FullChangeAllowed = "FULL_CHANGE_ALLOWED",
  AccountFilesChangeAllowed = "ACCOUNT_FILES_CHANGE_ALLOWED",
}
export default AccountingDocumentsInventoryChangeRestrictionLevel;
